module.exports = __webpack_public_path__ + "static/media/4.af1ee422.png";